
// 注册的全局插件
const plugins = []

export default {
  install(Vue) {
    plugins.forEach(plugin => {
      Vue.use(plugin)
    })
  }
}
